import React from 'react';
import './PageList.scss';

export type PageListProps = {
  pages: Page[];
};

// TODO Simplify the data for this with new api
type Page = {
  charityId?: string;
  campaignId?: string;
  title?: string;
  name?: string;
  url: string;
  logo: string;
};

export class PageList extends React.PureComponent<PageListProps> {
  render() {
    const { pages } = this.props;
    return (
      <ul className="jg-pages-teams-pagelist">
        {pages.map(page => (
          <li
            className="jg-pages-teams-pagelist-item"
            key={page.campaignId || page.charityId}
          >
            <a
              href={page.url}
              className="jg-pages-teams-pagelist-link"
              tabIndex={-1}
            >
              <div className="jg-pages-teams-pagelist-logo">
                <img src={`${page.logo}?template=size120x120`} alt="" />
              </div>
              <span className="jg-text--large">{page.name || page.title}</span>
            </a>
          </li>
        ))}
      </ul>
    );
  }
}

export default PageList;
